import { http } from "./http";

function parseApiError(error) {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return String(data.message);
  if (data?.error) return typeof data.error === "string" ? data.error : data.error?.message || "Erro na API de chat.";
  const status = error?.response?.status;
  if (status === 403) return "Sem permissão no módulo de chat desta empresa.";
  if (status === 401) return "Não autenticado. Faça login novamente.";
  return error?.message || "Erro na API de chat.";
}

function companyHeaders(companyId) {
  const id = String(companyId || "").trim();
  if (!id) throw new Error("companyId inválido.");
  return { id, headers: { "X-Company-ID": id } };
}

/**
 * GET /api/chat/canal/company/{companyId}/search-index/status
 * Retorna { indexedMessages, oldestIndexed, newestIndexed, job } — job é nulo se nenhuma
 * reindexação rodou desde a última subida da API.
 */
export async function getSearchIndexStatus(companyId) {
  const { id, headers } = companyHeaders(companyId);
  try {
    const { data } = await http.get(
      `/api/chat/canal/company/${encodeURIComponent(id)}/search-index/status`,
      { headers }
    );
    return data;
  } catch (error) {
    throw new Error(parseApiError(error));
  }
}

/**
 * POST /api/chat/canal/company/{companyId}/search-index/rebuild?sinceDays=
 * Sem sinceDays indexa todo o histórico. Lança erro com mensagem própria se já estiver rodando (409).
 */
export async function rebuildSearchIndex(companyId, sinceDays) {
  const { id, headers } = companyHeaders(companyId);
  const params = {};
  const days = Number.parseInt(String(sinceDays ?? ""), 10);
  if (Number.isFinite(days) && days > 0) params.sinceDays = days;
  try {
    const { data } = await http.post(
      `/api/chat/canal/company/${encodeURIComponent(id)}/search-index/rebuild`,
      null,
      { headers, params }
    );
    return data;
  } catch (error) {
    if (error?.response?.status === 409) {
      throw new Error("Já existe uma reindexação em andamento para esta empresa.");
    }
    throw new Error(parseApiError(error));
  }
}
